import ModalComponent from './modal/index.vue'

if (window.Vue && document.querySelector('#app')) {
  window.Vue.component('modal-component', ModalComponent)

  /* global $ */
  $(document).on('click', '[data-toggle="reservation"]', function () {
    let data = $(this).data('garage-id') || {}
    if (typeof data !== 'object') {
      data = {
        garage: data
      }
    }

    window.EventBus.$emit('lead:open', data)
  })
}
